import { render, staticRenderFns } from "./orderstatistics.vue?vue&type=template&id=69d7c0a7&scoped=true"
import script from "./orderstatistics?vue&type=script&lang=js&external"
export * from "./orderstatistics?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d7c0a7",
  null
  
)

export default component.exports